import { render, staticRenderFns } from "./add-bot-detection-rules.vue?vue&type=template&id=26d38e7a&"
import script from "./add-bot-detection-rules.vue?vue&type=script&lang=ts&"
export * from "./add-bot-detection-rules.vue?vue&type=script&lang=ts&"
import style0 from "./add-bot-detection-rules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports